import { ServiceStore } from "@intrasync/stores";
import { RouteType } from "types/RouteType";

const ProjectInitializationWizardRoute: RouteType = {
  name: "ProjectInitializationWizard",
  path: "/workflows/project-initialization",
  layout: "/app",
  group: "Workflows",
  requiresAuth: true,
  requiresPermission: false,
  viewportCard: {
    header: {
      title: "Project Initialization",
      component: () => import("./ProjectInitializationWizardHeader"),
      enableRefreshButton: false,
      enableBackButton: true,
    },
    body: {
      component: () => import("./ProjectInitializationWizard"),
      grayBackground: true,
    },
  },
  beforeEnter: async ({ rootStore }) => {
    try {
      // Load necessary data for the wizard
      const salesOrdersStore = rootStore.salesOrdersStore as ServiceStore;
      const accountsStore = rootStore.accountsStore as ServiceStore;
      const userStore = rootStore.userStore as ServiceStore;
      const jobStore = rootStore.jobStore as ServiceStore;

      await Promise.all([
        salesOrdersStore?.find(),
        accountsStore?.find(),
        userStore?.find(),
        jobStore?.find(),
      ]);

      return true;
    } catch (error) {
      console.error("Failed to load data for project initialization:", error);
      return false;
    }
  },
  onExit: ({ rootStore }) => {
    // Reset the wizard state when leaving
    const store = (rootStore as any).projectInitializationWizardStore;
    store?.reset();
  },
};

export default ProjectInitializationWizardRoute;
